  <template >
<div>

 <div  class="formPosition"     >
     <template>
  <v-container style="background-color:white;">
    <v-row no-gutters>
      <v-col >

<div class="text-center">

<div   :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>
      <img src="../../assets/dev.png" width="100px;" ><br>
    <span   style="font-size:14px; color:black;" > FUNCIONALIDADE EM FASE DE TESTES - ESTARÁ DISPONÍVEL EM BREVE</span><br>

  </div>
      </v-col>

    </v-row>
  </v-container>
</template>
   </div>
</div>
</template>

<script>
const ls = require('local-storage')
// const message = require('../config/messages')
export default {

  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  loggedUserName () {
    return ls.get('idPessoa')
  },
  created () {
    console.log(this.$store.state.actividades)
  },

  methods: {

  }
}
</script>
